var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"room",staticClass:"room"},[_c('vb-card',{attrs:{"variant":"horizontal","card":{
      image: _vm.room_image,
      title: _vm.room_name,
      text: _vm.room.description,
      text_clamped: true,
    }},on:{"click_image":function($event){return _vm.$bvModal.show(_vm.modal_id)}}},[(_vm.room.description)?_c('span',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.modal_id),expression:"modal_id"}],staticClass:"room__readmore"},[_vm._v("leggi tutto")]):_vm._e(),_c('vb-modal',{attrs:{"vb_options":{
        id: _vm.modal_id,
        body_class: 'room__modal',
        centered: true,
        hide_footer: true,
        size: 'lg'
      }}},[(_vm.room_image)?_c('img',{staticClass:"room__modal-image",attrs:{"src":_vm.room_image,"alt":_vm.room_name}}):_vm._e(),_c('h5',{staticClass:"room__modal-title",domProps:{"innerHTML":_vm._s(_vm.room_name)}}),_c('p',{staticClass:"room__modal-description",domProps:{"innerHTML":_vm._s(_vm.room.description)}})]),(_vm.rates.length)?_c('div',{staticClass:"room__footer"},[_c('div',{staticClass:"room__rates"},[_c('vb-select',{attrs:{"vb_options":{
            options: _vm.rate_options,
            value: _vm.selected_rate_idx,
          }},model:{value:(_vm.selected_rate_idx),callback:function ($$v) {_vm.selected_rate_idx=$$v},expression:"selected_rate_idx"}}),(_vm.current_rate && _vm.current_rate.pricing)?_c('span',{staticClass:"room__price"},[_vm._v(" "+_vm._s(_vm.markup(_vm.current_rate.pricing.total).display_price)+"€ ")]):_vm._e()],1),_c('vb-button',{attrs:{"vb_options":{
          text: _vm.is_selected ? 'Selezionata' : 'Scegli',
          variant: _vm.is_selected ? 'outline-info' : 'dark',
          size: 'md',
          disabled: _vm.is_selected,
        }},on:{"click":_vm.select_room}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }